<template>
    <modal
        name="modalProgramGroupContributionHistory"
        :width="'60%'"
        :height="'auto'"
        :click-to-close="false"
    >
        <button type="button"
            class="btn btn-danger btn-sm btn-closed"
            @click="closeModal">
            <i class="fa-solid fa-xmark"></i>
        </button>

        <div class="modal-header">
            <h5 class="modal-title">
                Historial de aportaciones – {{ user_name }}
            </h5>
        </div>

        <div class="modal-body">

            <div v-if="loading" class="text-center my-4">
                <i class="fa-solid fa-circle-notch fa-spin fa-3x"></i>
                <p>Cargando historial…</p>
            </div>

            <div v-else>
                <table class="table table-bordered text-center">
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Monto</th>
                            <th>Origen</th>
                            <th>Forma de pago</th>
                            <th>Opciones</th>
                        </tr>
                    </thead>

                    <tbody v-if="history.length > 0">
                        <tr v-for="h in history" :key="h.id">
                            <td>{{ h.date }}</td>
                            <td>{{ h.amount | toCurrency }}</td>
                            <td>{{ h.source_name }}</td>
                            <td>{{ h.type_payments_id ?? 'N/A' }}</td>

                            <td>
                                <button
                                    class="btn btn-sm btn-outline-danger m-1" v-can="'delete_programs_investors'"
                                    @click="confirmDelete(h.id)"
                                >
                                    <i class="fa-solid fa-trash"></i> Eliminar
                                </button>
                                <a
                                    class="btn btn-sm btn-outline-info m-1"
                                    target="_blank"
                                    :href="`${globalUrlFiles}/contributions?program_id=${h.id}`">                                
                                    <i class="fa-solid fa-file"></i> Recibo
                                </a>
                                <button
                                    class="btn btn-sm btn-outline-primary m-1"
                                    @click="sendVoucher(h.id)"
                                >
                                    <i class="fa-solid fa-envelope"></i> Enviar recibo
                                </button>
                                <h5 v-if="h.send == 1"><span class="badge bg-success notification-badge m-1">
                                    <i class="fa-regular fa-circle-check"></i> Correo enviado</span>
                                </h5>
                            </td>
                        </tr>
                    </tbody>

                    <tbody v-else>
                        <tr>
                            <td colspan="5">Sin aportaciones registradas.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="mt-3">
                <button type="button"
                    class="btn btn-outline-secondary float-right"
                    @click="closeModal">
                    Cerrar
                </button>
            </div>
            <br>
            <br>
        </div>
    </modal>
</template>


<script>
import request from "@/services/request";
import { mapActions } from "vuex";

export default {
    data() {
        return {
            loading: true,
            program_group_id: "",
            user_id: "",
            user_name: "",
            company_id: "",
            history: [],
            user_email: ''
        };
    },

    methods: {
        async loadHistory() {
            this.loading = true;

            try {
                let url = `/program-group-contributions/${this.program_group_id}/user/${this.user_id}/${this.company_id}`;
                let { data } = await request.get(url);

                this.history = data;
            } catch (error) {
                console.log(error);
            }

            this.loading = false;
        },
        sendVoucher(contributionId) {
            let email = this.user_email;
            Event.$emit("event-send-voucher-contribution", contributionId, email);
        },

        closeModal() {
            this.history = [];
            this.loading = false;
            this.$modal.hide("modalProgramGroupContributionHistory");
        },

        confirmDelete(id) {
            this.$swal({
                title: "¿Eliminar aportación?",
                text: "Esta acción no borra el historial, solo marcará el registro como eliminado.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Eliminar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.deleteContribution(id);
                }
            });
        },

        async deleteContribution(id) {
            try {
                let { data } = await request.destroy(`/program-group-contributions/${id}`);

                this.successNotification(data.message);

                await this.loadHistory();

                // Recargar vista A
                Event.$emit("event-reload-program-relations");

            } catch (error) {
                this.errorNotification(error);
            }
        },

        ...mapActions({
            errorNotification: "alert/error",
            successNotification: "alert/success",
        }),
    },

    created() {
        Event.$on(
            "event-open-program-group-contribution-history",
            async (payload) => {
                this.program_group_id = payload.program_group_id;
                this.user_id = payload.user_id;
                this.company_id = payload.company_id;
                this.user_name = payload.user_name ?? "";
                this.user_email = payload.user_email ?? "";
                console.log(payload);
                this.$modal.show("modalProgramGroupContributionHistory");

                await this.loadHistory();
            }
        );
        Event.$on(
            "event-reload-program-relations-current",
            async () => {
                await this.loadHistory();
            }
        );
    },
};
</script>

<style scoped>
.notification-badge {
    border-radius: 30px;
    padding: 7px;
}
.text-danger {
    font-size: 12px;
}
</style>
